<template>
    <div class="index">
        <portal to="title">Sessions</portal>
        <portal to="actions">
            <div class="row">
                <div
                    class="offset-md-6 col-md-6 offset-sm-0 col-sm-12 mb-4 d-flex justify-content-lg-end justify-content-sm-between"
                    v-if="(paginator && paginator.data && paginator.data.length) || paginatorOptions.search.length"
                >
                    <vue-search-input
                        placeholder="Search sessions"
                        v-on:search="
                            paginatorOptions.search = $event;
                            paginatorOptions.page = 1;
                        "
                        :loading="loading"
                    />
                </div>
            </div>
        </portal>

        <vue-table
            :paginator="paginator"
            :rows="3"
            :columns="3"
            :loading="loading"
            v-on:retrieve-page="paginatorOptions.page = $event"
        >
            <template v-slot:card="data">
                <h6 class="card-header-session">{{ data.item.discipline.name }}</h6>

                <div class="card-body px-4 pt-4">
                    <p class="text-muted my-2">
                        Therapist: <span class="text-blue-dark pl-1">{{ data.item.therapist.f_name }}</span>
                    </p>
                    <p class="text-muted my-2">
                        Patient: <span class="text-blue-dark pl-1">{{ data.item.patient.f_name }}</span>
                    </p>
                    <p class="text-muted my-2">
                        Session: <span class="text-blue-dark pl-1">{{ data.item | time }}</span>
                    </p>
                </div>

                <div class="card-footer text-muted bg-white border-0 pb-4 rounded-lg px-4">
                    <hr class="mb-4 mt-0" />

                    <div class="d-flex align-items-center">
                        <p class="text-muted my-2">Total cost (excl. travel):</p>

                        <span class="text-blue-dark pl-1"> £{{ data.item.cost }}</span>
                    </div>
                </div>
            </template>
        </vue-table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';

    import VueTable from '@components/table';
    import VueSearchInput from '@components/searchInput';

    import sessionsService from '@api/sessions';

    export default Vue.extend({
        components: {
            VueTable,
            VueSearchInput
        },
        data() {
            return {
                paginator: {},
                paginatorOptions: {
                    page: this.$route.query.page || 1,
                    search: this.$route.query.search || ''
                },
                loading: true
            };
        },
        filters: {
            time(value) {
                return (
                    moment(value.session_start).format('HH:mm') +
                    moment(value.session_end).format(' - HH:mm, DD MMM YYYY')
                );
            }
        },
        watch: {
            paginatorOptions: {
                deep: true,
                handler() {
                    this.fetch();
                }
            }
        },
        methods: {
            fetch() {
                this.loading = true;

                sessionsService
                    .index(this.paginatorOptions)
                    .then((response) => {
                        this.paginator = response.data;
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.fetch();
        }
    });
</script>
